exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".galaxy\\:\\:common-canvas-blocks-utils-image-BlockPanel .dropzone[data-v-412eb061]{border-width:1px}.galaxy\\:\\:common-canvas-blocks-utils-image-BlockPanel .dropzone.success[data-v-412eb061]{border-color:rgba(40,167,69,.3411764706);border-style:solid;background-color:#fbfffc}", ""]);

